/* @flow */
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
const defaultHeight = 60
const Logo = ({ link, title }) => {
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  return (
    <div>
      <Link to={link}>
        <span style={{ color: '#FFF', fontSize: defaultHeight * deviceSize }} className="nsg-glyph--swoosh" />
        <span style={{ color: '#FFF', fontSize: '26px', marginLeft: 5 }}>{title}</span>
      </Link>
    </div>
  )
}

export default Logo
